import GRID_CALLBACK_TYPES from "@/constants/grid";

export default {
	id: null,
	type: GRID_CALLBACK_TYPES.MASK_UPDATE,
};
